import axios from "axios";
import { apiFiles } from "../config";
import { axiosInstanceWithMainApiToken } from "./axios.config";

export const sendFile = async (payload) => {
  const { data } = await axiosInstanceWithMainApiToken.post(`${apiFiles}/files`, payload);
  return data;
};
